import { render, staticRenderFns } from "./DramaEpisodeManagement.vue?vue&type=template&id=5598f540&scoped=true"
import script from "./DramaEpisodeManagement.vue?vue&type=script&lang=js"
export * from "./DramaEpisodeManagement.vue?vue&type=script&lang=js"
import style0 from "./DramaEpisodeManagement.vue?vue&type=style&index=0&id=5598f540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5598f540",
  null
  
)

export default component.exports